export const isPC = () => window.innerWidth > 800;
